// extracted by mini-css-extract-plugin
module.exports = {"container":"Blocked_container__1scP9","moreInfo":"Blocked_moreInfo__1mFQO"};